import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { filter, find } from 'lodash';

import Select from '../../../elements/Select';
import withLocalization from '../../../hoc/withLocalization';

const ProjectsWidgetMobx = inject('projectStore', 'userStore')(withLocalization(observer(class ProjectsWidgetMobx extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initted: false,
            page: 0
        }
        this.loadOptionsDebounced = null;
        this.currentInputValue = '';
    }

    componentDidMount() {
        this.handleLoadInitialOptions();
    }

    handleLoadInitialOptions = () => {
        const { projectStore, options, filterByUser, fromShift, userId } = this.props;
        const _user_id = options && options.user_id ? options.user_id : filterByUser ? filterByUser : userId;
        this.currentInputValue = '';
        this.setState({ page: 0 });
        projectStore.loadLookup(undefined, _user_id, 0, fromShift);
    };

    componentWillUnmount() {
        if(this.loadOptionsDebounced) clearTimeout(this.loadOptionsDebounced);
    }

    componentDidUpdate(prevProps) {
        const { applyOnFirstLoad, value, onChange, projectStore , isShiftEdit } = this.props;
        const { initted } = this.state;
        const { loadingLookup, currentProjectsLookup } = projectStore;

        if (
            (!loadingLookup &&
                currentProjectsLookup.rows &&
                currentProjectsLookup.rows.length &&
                applyOnFirstLoad &&
                !initted) ||
            (!loadingLookup &&
                currentProjectsLookup.rows &&
                currentProjectsLookup.rows.length &&
                prevProps.filterByUser !== this.props.filterByUser)
        ) {
            const rows = this.prepareOptions(currentProjectsLookup.rows);
            let row = find(rows, (row) => `${row.value}` === `${value}`);
            if (!row && !isShiftEdit) {
                row = rows.length ? rows[0] : null;
            }
            this.setState({ initted: true });
            if (row) {
                onChange(row.value, row);
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        const { userId = undefined, options, fromShift , filterByUser } = this.props;
        const cache = options && options.user_id ? options.user_id : filterByUser ? filterByUser : userId;
        const ncache = nextProps.options && nextProps.options.user_id ? nextProps.options.user_id : nextProps.filterByUser ? nextProps.filterByUser : (nextProps.userId || undefined);
        if(cache !== ncache) {
            this.setState({ currentPage: 0 })
            nextProps.projectStore.loadLookup(undefined, ncache, 0, fromShift).then(list => {
                this.prepareOptions(list);
            })
        }
    }

    handleInputChange = (newValue, actionMeta) => {
        if(actionMeta.action === 'input-change') {
            this.currentInputValue = newValue;
            this.setState({ page: 0 });
            return newValue;
        }
        return newValue;
    };


    handleChange = (id) => {
        const { onChange } = this.props;
        if (!id || !id.value) {
            this.handleLoadInitialOptions();
            onChange(null, null);
        } else {
            onChange(id.value, id);
        }
    };

    handleMenuScrollToBottom = async () => {
        const { projectStore, options, filterByUser, userId = undefined , fromShift} = this.props;
        const { page } = this.state;
        const inputValue = this.currentInputValue ? this.currentInputValue : undefined;
        const _user_id = options && options.user_id ? options.user_id : filterByUser ? filterByUser : userId;
        const hasMore = page + 1 < projectStore.currentProjectsLookup.pages ? true : false;
        if(!hasMore) return;
        const nextPage = page + 1;
        await projectStore.loadLookup(inputValue, _user_id, nextPage, fromShift);
        this.prepareOptions(projectStore.currentProjectsLookup.rows);
        this.setState({ page : nextPage });
    }

    loadOptions = (inputValue, callback) => {
        if(this.loadOptionsDebounced) clearTimeout(this.loadOptionsDebounced);
        const { projectStore, options, filterByUser , fromShift} = this.props;
        const _user_id = options && options.user_id ? options.user_id : filterByUser ? filterByUser : undefined;
        this.currentInputValue = inputValue;

        this.loadOptionsDebounced = setTimeout(() => {
            projectStore.loadLookup(inputValue, _user_id, 0, fromShift).then((list) => {
                const preparedOptions = this.prepareOptions(list);
                this.setState({ page : 0 });
                callback(preparedOptions);
            })
        }, 300);
    }

    prepareOptions = (array) => {
        const { allowAll, t, allLabel } = this.props;
        let _array = array
         _array = array
            ? _array.map((pm) => {
                return { value: `${pm.id}`, label: `${pm.project_number} | ${pm.name}` };
            })
            : [];
        if (allowAll) {
            _array.unshift({ value: '', label: t(allLabel || 'All') });
        }
        return _array;
    };

    render() {
        const { value, onChange, projectStore, disabled, label, error, allowAll, t, menuPlacement, maxMenuHeight } = this.props;
        const { currentProjectsLookup } = projectStore;
        const options = this.prepareOptions(currentProjectsLookup.rows);
        const currentSelect = find(options, (o) => {
            if (allowAll && !value)
                return String(o.value) === String('') || String(o.value) === String('all')
            if (value === 'all')
                return String(o.value) === String('') || String(o.value) === String('all');
            return String(o.value) === String(value);
        });
        const inputView = false;
        return (
            <div className={`managers-widget ${inputView ? 'input-block' : ''}`}>
                {inputView && <span className="input-block__label">{label}</span>}
                <Select
                    asyncSelect
                    options={options}
                    defaultOptions={options}
                    cacheOptions={true}
                    inputView={inputView}
                    error={error}
                    value={currentSelect ?? null}
                    isDisabled={disabled}
                    isClearable={true}
                    placeholder={t("Select project")}
                    onChange={this.handleChange}
                    style={{ width: '100%' }}
                    onMenuScrollToBottom={this.handleMenuScrollToBottom}
                    loadOptions={this.loadOptions}
                    isLoading={projectStore.loadingLookup}
                    onInputChange={this.handleInputChange}
                    menuPlacement={menuPlacement}
                    maxMenuHeight={maxMenuHeight}
                />
            </div>
        );
    }
})));

export const ProjectsWidget = observer(class ProjectsWidget extends Component {
    render() {
        return <ProjectsWidgetMobx {...this.props} />;
    }
});
